export const BackArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1104_1846"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect
          x="24"
          y="24"
          width="24"
          height="24"
          transform="rotate(180 24 24)"
          fill="var(--swapper-text-color)"
        />
      </mask>
      <g mask="url(#mask0_1104_1846)">
        <path
          d="M10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18L4 12L10 6Z"
          fill="var(--swapper-text-color)"
        />
      </g>
    </svg>
  );
};
